// src/components/alert-title/styles.ts
var alertTitle = {
  info: {
    color: "var(--colors-blue-50)"
  },
  negative: {
    color: "var(--colors-red-50)"
  },
  positive: {
    color: "var(--colors-green-50)"
  },
  warning: {
    color: "var(--colors-orange-50)"
  },
  neutrals: {
    color: "var(--colors-neutrals-100)"
  }
};

export {
  alertTitle
};
